import Home from "./home/index.js";
import Reform from "./reform/index.js";
import Assessment from "./assessment/index.js";
import Column from "./column/index.js";
import Estate from "./estate/index.js";
import EstateDetail from "./estate/detail.js";
import SearchArea from "./search/area.js";
import SearchStation from "./search/station.js";
//import SearchSchool from "./search/school.js";
import caseGallery from "./case/index.js";
import sold from "./sold/index.js";
import SoldResult from "./sold/result.js";
import SoldDetail from "./sold/detail.js";
import Favorite from "./favorite/index.js";
import History from "./history/index.js";
import SearchMap from "./search/map/index.js";
import AiAssessment from "./ai-assessment/index.js";
import Company from "./company/index.js";

const pages = () => {
    Home();
    Column();
    Reform();
    Assessment();
    Estate();
    EstateDetail();
    SearchArea();
    SearchStation();
    //SearchSchool();
    SearchMap();
    caseGallery();
    sold();
    SoldResult();
    SoldDetail();
    Favorite();
    History();
    AiAssessment();
    Company();
};
export default pages;
